<template>
  <div>
    <i-spin v-if="false" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
    <div class="send-bind-card">
      <p class="title">Confirm your charges</p>
      <div style="margin-top: 20px">
        <BillBackDetail :info-prepayment="infoPrepayment" />
      </div>
    </div>
    <div class="send-bind-card">
      <Button :loading="payLoading" class="confirm" style="font-weight: 500" @click="pay()">
        Pay ${{ infoPrepayment.fee }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '../../../components/button/Button';
import { API } from '@/net/http';
import BillBackDetail from '@/views/bill/components/BillBackDetail.vue';
export default {
  components: {
    BillBackDetail,
    Button,
  },
  props: ['backId'],
  data() {
    return {
      loading: true,
      isDefault: false,
      orderNum: this.$route.params.orderNumber,
      hasDefault: false,
      bindNew: false,
      defaultCardNumber: '',
      infoPrepayment: {},
      showBillBox: false,
      billId: null,
      payLoading: false,
    };
  },
  mounted() {
    this.fetchBackBillInfo();
    document.addEventListener('visibilitychange', this.handleTabVisible);
  },
  methods: {
    handleTabVisible(e) {
      if (e.target.visibilityState === 'visible') {
        this.$post(API.backExpireTime, { backId: this.backId }).then(res => {
          if (!res.success) {
            this.$emit('init-countdown', -1);
            return;
          }
          this.infoPrepayment.secondsRemaining = res.data;
          this.$emit('init-countdown', res.data);
        });
      }
    },
    fetchBackBillInfo() {
      this.$emit('change-loading', true);
      this.$post(API.backBillInfo, { backId: this.backId })
        .then(res => {
          if (!res.success) return;
          const data = res.data;
          this.infoPrepayment = data;
          this.billId = data.billId;
          this.$emit('init-countdown', data.secondsRemaining);
          this.loading = false;
        })
        .finally(() => {
          this.$emit('change-loading', false);
          this.payLoading = false;
        });
    },
    pay() {
      if (this.payLoading) return;
      this.payLoading = true;
      this.$post(API.backBillPay, { backId: this.backId, billId: this.billId })
        .then(res => {
          if (!res.success) {
            this.$emit('change-payment-failed', true);
            return;
          }
          this.$Message.success('success');
          this.$emit('change-route', 'boxstatus');
        })
        .finally(() => {
          this.payLoading = false;
        });
    },
    changeBillBoxShow() {
      this.showBillBox = !this.showBillBox;
    },
    showExpiredDialog() {
      this.$Modal.warning({
        title: 'Unpaid for over 30 minutes!<br />Shipping label canceled! Please place another new order.',
        width: 500,
        onOk: () => {
          this.$emit('change-route', 'boxstatus');
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';

.send-bind-card {
  .title {
    .font-regular;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 6px;
  }
  .confirm {
    width: 146px;
    margin: 36px auto 0;
  }
}
.change-button {
  color: @app-blue-color;
}
.card {
  .font-regular;
  background-color: #fbfbfb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  height: 66px;
  margin-top: 30px;

  .card-icon {
    width: 40px;
    height: 40px;
    margin: 0 20px;
  }
  .card-title {
    color: #333333;
    font-size: 15px;
  }
  .card-text {
    color: #333333;
    font-size: 12px;
  }
}
.prepay-box {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  .prepay-left {
    display: flex;
    align-items: center;
  }
  .prepay-right {
    display: flex;
    align-items: center;
    text-align: right;
  }
}
.bill-box {
  margin: 20px 40px;
  background: #fbfbfb;
  .bill-item {
    height: 40px;
    margin: 0 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .bill-item:last-of-type {
    border-bottom: none;
  }
}
</style>
